export default {
  contactPage: {
    title: "Contact",
    subtitle: "I'd love to hear from you!",
    catchphrase:
      "Whether you have a question, a project idea, or just want to say hello, feel free to drop me a message using the form below. I'm always excited to connect with new people and explore potential collaborations.",
    successMessage: "Message sent successfully!",
    errorMessage: "An error occurred while sending your message.",
    form: {
      emailPlaceholder: "Your email",
      namePlaceholder: "Name",
      messagePlaceholder: "Your message",
      sendButton: "Send Message",
      sendingButton: "Sending...",
      emailError: "Invalid email address",
      nameError: "Name is required",
      messageError: "Message is required",
    },
  },
}
